import { Item, ItemHeader, ItemTitle } from '@ibsys/kit';
import { StarIcon } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/lib';
import { LabeledIcon, TruncatedText } from '@/shared/ui';
import type { TablePreset } from '@/entities/settings';
import { PresetKindIcons } from './PresetKindIcons';

type Props = {
  preset: TablePreset;
  /** Активный (применённый) пресет — подсвечивается */
  isActive: boolean;
  onApply: () => void;
};

/**
 * Строка пресета в списке: клик применяет пресет. Управление пресетом живёт не здесь, а рядом
 * с кнопкой «Пресеты» ({@link PresetActions}) — строка несёт только название и значки состояния.
 */
export const PresetItem: FC<Props> = ({ preset, isActive, onApply }) => {
  const { t } = useTranslation('tablePresets');
  return (
    <Item
      variant="outline"
      size="sm"
      role="button"
      tabIndex={-1}
      onClick={onApply}
      className={cn('cursor-pointer hover:bg-muted/60 p-2 w-full min-w-0', isActive && 'border-primary bg-primary/5')}
    >
      <ItemHeader className="min-w-0 min-h-9 gap-2">
        <PresetKindIcons
          preset={preset}
          labels={{
            system: t('systemPreset'),
            shared: t('sharedPreset'),
            sharedBy: (owner) => t('sharedBy', { owner }),
          }}
        />
        <ItemTitle className="block w-full min-w-0 text-sm">
          <TruncatedText>{preset.name}</TruncatedText>
        </ItemTitle>
        {preset.pinned && (
          <LabeledIcon label={t('pinnedToMenu')} icon={<StarIcon className="size-3.5 fill-current" />} />
        )}
      </ItemHeader>
    </Item>
  );
};
